import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import IMask from 'imask';
import { filter, first } from 'rxjs/operators';
import { GlobalUtilsService } from 'src/app/global-utils.service';
import { ContactFormFocusInteractorService } from '../contact-form-focus-interactor.service';
import { FormControlName } from '../contact-form-types';
import { ContactFormService } from '../contact-form.service';

@Component({
  selector: 'app-input-text',
  template: `
    <div
      class="input-container"
      (click)="onFocus($event)"
      [ngClass]="{
        disabled: isDisabled,
        isFocused: isFocused,
        tablet: globalUtilsService.isTablet(),
        mobile: globalUtilsService.isMobile()
      }"
    >
      <span
        class="label"
        [ngClass]="{
          'on-top': isFocused || control.value,
          invalid: control.invalid && control.touched && !isFocused
        }"
        >{{ isFocused || control.value ? label : placeholder }}</span
      >
      <div class="input-control-container">
        <input
          #input
          [tabindex]="isDisabled ? -1 : 0"
          *ngIf="!mask && !maskMode"
          [ngClass]="{ isFocused: isFocused, hide: !isFocused }"
          class="input-control"
          [formControl]="control"
          (focus)="onFocus($event)"
          (blur)="blur($event)"
        />
        <input
          #input
          [tabindex]="isDisabled ? -1 : 0"
          *ngIf="mask"
          [imask]="mask"
          [formControl]="control"
          [ngClass]="{ isFocused: isFocused, hide: !isFocused }"
          class="input-control"
          (focus)="onFocus($event)"
          (blur)="blur($event)"
        />
        <input
          [tabindex]="isDisabled ? -1 : 0"
          #input
          *ngIf="maskMode"
          [ngClass]="{ isFocused: isFocused, hide: !isFocused }"
          class="input-control"
          (focus)="onFocus($event)"
          (blur)="blur($event)"
        />
        <p
          class="input-control-deactivate"
          *ngIf="!isFocused"
          [ngClass]="{ invalid: control.invalid && control.touched }"
        >
          {{ control.value }}
        </p>
      </div>
    </div>
  `,
  styleUrls: [`../input-control.scss`],
})
export class InputTextComponent implements OnInit, AfterViewInit {
  @Input()
  label: string;

  @Input()
  placeholder: string;

  @Input()
  control: FormControl;

  @Input()
  controlName: FormControlName;

  @Input()
  mask: any;

  @Input()
  maskMode: 'phone' | 'other';

  // tslint:disable-next-line: no-output-native
  @Output()
  focusBlur: EventEmitter<boolean>;

  isFocused: boolean;

  @ViewChild('input', { static: false })
  inputElement: ElementRef;

  isDisabled: boolean;

  constructor(
    private ngZone: NgZone,
    public globalUtilsService: GlobalUtilsService,
    private contactFormFocusInteractorService: ContactFormFocusInteractorService,
    private contactFormService: ContactFormService
  ) {
    this.isFocused = false;
    this.focusBlur = new EventEmitter();
  }

  ngAfterViewInit(): void {
    if (this.maskMode === 'phone') {
      this.setupPhoneMask();
    }

    this.contactFormFocusInteractorService.focus
      .pipe(filter((v) => v === this.controlName))
      .subscribe({
        next: () => {
          this.focusNow();
        },
      });
  }

  private focusNow(): void {
    if (this.isDisabled) {
      return;
    }
    this.focusBlur.emit(true);
    this.isFocused = true;
    // this.contactFormService.activeControl.emit(this.controlName);
    this.ngZone.onMicrotaskEmpty.pipe(first()).subscribe(() => {
      // if (e instanceof MouseEvent) {
      (this.inputElement.nativeElement as HTMLFormElement).focus();
      // }
    });
  }

  private setupPhoneMask() {
    const m = IMask(this.inputElement.nativeElement, {
      mask: '(00)0000-0000[0]',
    });

    m.on(
      'accept',
      (() => {
        console.log(m.value);

        if (m.value && m.value.length > 14) {
          m.updateOptions({
            mask: '(00) 00000-0000',
          });
        } else {
          m.updateOptions({
            mask: '(00) 0000-0000[0]',
          });
        }
        this.control.patchValue(m.value);
        this.control.updateValueAndValidity();
      }).bind(this)
    );
  }

  ngOnInit() {
    this.isDisabled = this.contactFormService.disabledInputs[
      this.controlName
    ].value;
    this.contactFormService.disabledInputs[this.controlName].subscribe(
      (isDisabled) => {
        this.isDisabled = isDisabled;
      }
    );
  }

  onFocus(e) {
    this.focusNow();
  }

  blur(e) {
    this.focusBlur.emit(false);
    this.isFocused = false;
  }
}
